import { Component, ElementRef, Input ,ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, take, takeUntil } from 'rxjs';
import { FormGroup, Validators } from '@angular/forms';
import { createRuleInRConstants } from '../../../shared/utilities/Constants';
import { ToastrService } from 'ngx-toastr';
import * as InitReleaseActions from '../../actions/init-release.actions';
import { selectCallCustomRulesDeleteSuccess, selectCallCustomRulesDeleteFailed } from '../../reducers';

@Component({
  standalone: false,
    selector: 'mm-init-release-delete-rule-modal',
    templateUrl: './init-release-delete-rule-modal.component.html',
    styleUrls: ['./init-release-delete-rule-modal.component.scss']
})
export class InitReleaseDeleteRuleModalComponent {
    @ViewChild('deleteRuleModal') public deleteRuleModal: ElementRef;
    destroy$: Subject<boolean> = new Subject<boolean>();
    createRuleModalFormGroup: FormGroup = new FormGroup({});
    bannerErrorText: string = createRuleInRConstants.callToCustomRuleDeleteFailedText;
    showErrorBanner: boolean = false;
    currentRuleId: string = '';

    createRuleConstants = createRuleInRConstants;

    ngOnInit(): void {

    }
    
    onCancelClick(): void {
        this.showErrorBanner = false;
        this.deleteRuleModal.nativeElement.hideModal();
    }

    onModalDeleteButtonClick(): void {
        this.store.dispatch(InitReleaseActions.callCustomRulesDeleteByRuleId({ruleId: this.currentRuleId}));
        this.store.select(selectCallCustomRulesDeleteSuccess).pipe(take(2)).subscribe(success => {
            if (success) {
                this.store.dispatch(InitReleaseActions.callCreateCustomRulesGet());
                this.toastr.success(createRuleInRConstants.deleteModalSuccessToastrMessage);
                this.deleteRuleModal.nativeElement.hideModal();
            }
        });
        this.store.select(selectCallCustomRulesDeleteFailed).pipe(takeUntil(this.destroy$)).subscribe(failure => {
            if (failure) {
                this.showErrorBanner = true;
            }
        })
    }

    onDeleteLinkClickedEvent(ruleId: string): void {
        this.currentRuleId = ruleId;
        this.deleteRuleModal.nativeElement.showModal();
    }

    constructor(
        private store: Store,
        private toastr: ToastrService,
    ) { }
}